import type { AuthUser } from '@gyym/sdk'
import React from 'react'

import { useGyymClient } from '#hooks/useGyymClient'
import { useGyymSWR } from '#hooks/useGyymSWR'

export const GyymAuthUserContext = React.createContext<{
  user: AuthUser | null
  isLoading: boolean
}>({ user: null, isLoading: true })

const useInternalAuthUser = () => {
  const client = useGyymClient()
  return useGyymSWR(client.auth.user.get, {
    revalidateOnFocus: false,
    revalidateOnMount: true,
  })
}

export interface GyymAuthUserProviderProps {
  children: React.ReactNode
}

export const GyymAuthUserProvider = ({
  children,
}: GyymAuthUserProviderProps) => {
  const { data: user, isValidating } = useInternalAuthUser()

  const value = React.useMemo(
    () => ({ user: user ?? null, isLoading: isValidating }),
    [user, isValidating],
  )

  return (
    <GyymAuthUserContext.Provider value={value}>
      {children}
    </GyymAuthUserContext.Provider>
  )
}
